import { runConvexMutation, runConvexQuery } from '@/lib/convex';

/**
 * Frontend service for linking a guest shelf purchase to the signed-in account.
 *
 * Phase 3 of docs/plans/2026-08-25-sku-shelf-portal-plan.md. Two calls, both
 * against `convex/shelfClaims.ts`:
 *
 *   getPendingShelfPurchases()  → count only. Cheap enough to run on portal load.
 *   claimShelfPurchases()       → writes purchases + entitlements + library rows.
 *
 * Both return null when Convex is not configured for the build (same contract
 * as every other service in this folder), which the caller treats as "nothing
 * to do" rather than an error.
 */

export interface ShelfPendingSummary {
  pending: number;
  /** Why nothing can be matched, when that is knowable. Diagnostics only. */
  blocked?: 'no_email' | 'email_not_verified' | null;
}

export interface ShelfClaimResult {
  claimed: number;
  /** Display names of what was added, for the confirmation line. */
  products: string[];
  blocked?: 'no_email' | 'email_not_verified' | null;
}

export async function getPendingShelfPurchases(token?: string | null) {
  return runConvexQuery<ShelfPendingSummary | null>('shelfClaims:getPendingForCurrentUser', {}, token);
}

export async function claimShelfPurchases(token?: string | null) {
  return runConvexMutation<ShelfClaimResult | null>('shelfClaims:claimForCurrentUser', {}, token);
}
